// Builds a CSS grid template where a whole column (track) is wide when any of its cells is long.
// Row-flow places cell i in column i % columnCount, so wide flags fold onto their track.
export const getDetailColumnTemplate = (
  wideFlags: boolean[],
  columnCount: number,
  narrowFr: number,
  wideFr: number
): string | undefined => {
  if (columnCount <= 0 || wideFlags.length === 0) {
    return undefined;
  }
  const cols = Math.min(columnCount, wideFlags.length);
  const tracks: number[] = new Array(cols).fill(narrowFr);
  wideFlags.forEach((wide, i) => {
    if (wide) {
      tracks[i % cols] = wideFr;
    }
  });
  return tracks.map((fr) => `minmax(0, ${fr}fr)`).join(' ');
};
